import RiepilogoNc from "./RiepilogoNc";
import { legacyNcRedirect } from "./include/ncList.mjs";
import CustomerReturnPage from "./CustomerReturnPage";
import MailSegnalazioni from "./MailSegnalazioni";
import StampaOdr from "./StampaOdr";

import store from "../../store"

const ifAuthenticated = (to, from, next) => {
    if (store.getters.isLoggedIn) {
        next()
        return
    }
    next('/login')
}

export default [
    {path: '/qualita/nc-interne/', name: 'qualita-nc-interne', meta: {menu: 'qualita', title: 'NC interne'}, component: () => import('./nc-interne/NcInternePage.vue'), beforeEnter: ifAuthenticated},
    {path: '/qualita/nc-interne/:numero', name: 'qualita-nc-interne-dettaglio', meta: {menu: 'qualita', title: 'NC interne'}, component: () => import('./nc-interne/NcInternePage.vue'), beforeEnter: ifAuthenticated},
    {path: '/qualita/ppap/:id/disegno/', name: 'qualita-ppap-editor', meta: {title: 'Pallinatura PDF', fullscreen: true}, component: () => import('./ppap/PpapPdfEditor.vue'), beforeEnter: ifAuthenticated},
    {path: '/qualita/ppap/da-fare/', name: 'qualita-ppap-da-fare', meta: {menu: 'qualita', title: 'PPAP da fare'}, component: () => import('./ppap/PpapTodoPage.vue'), beforeEnter: ifAuthenticated},
    {path: '/qualita/ppap/cruscotto/', name: 'qualita-ppap-cruscotto', redirect: {name: 'qualita-ppap-da-fare'}},
    {
        path: '/qualita/ppap/',
        name: 'qualita-ppap',
        meta: {menu: 'qualita', title: 'Nuovo PPAP'},
        component: () => import('./ppap/PpapPage.vue'),
        beforeEnter: ifAuthenticated,
    },
    {
        path: '/qualita/ppap/realizzati/',
        name: 'qualita-ppap-realizzati',
        meta: {menu: 'qualita', title: 'PPAP realizzati'},
        component: () => import('./ppap/PpapPage.vue'),
        beforeEnter: ifAuthenticated,
    },
    {
        path: '/qualita/ppap/certificati-materiali/',
        name: 'qualita-ppap-certificati',
        meta: {menu: 'qualita', title: 'Certificati 3.1 materiali'},
        component: () => import('./ppap/PpapCertificatesPage.vue'),
        beforeEnter: ifAuthenticated,
    },
    {
        path: '/qualita',
        redirect: {name: 'qualita-mail-segnalazioni'},
    },
    {
        path: '/qualita/stampa-odr/',
        name: 'qualita-stampa-odr',
        meta: {menu: 'qualita', title: 'Stampa ODR'},
        component: StampaOdr,
        beforeEnter: ifAuthenticated,
    },
    {
        path: '/qualita/mail-segnalazioni/',
        name: 'qualita-mail-segnalazioni',
        meta: {menu: 'qualita', title: 'Mail Segnalazioni'},
        component: MailSegnalazioni,
        beforeEnter: ifAuthenticated,
    },
    {
        path: '/qualita/ricevimentonc',
        name: 'qualita-ricevimento-nc',
        meta: {menu: 'qualita', title: 'Ricevimento NC'},
        component: CustomerReturnPage,
        beforeEnter: ifAuthenticated,
    },
    {
        path: '/qualita/riepologonc/',
        name: 'qualita-riepilogo-nc',
        meta: {menu: 'qualita', title: 'Riepilogo NC'},
        component: RiepilogoNc,
        beforeEnter: ifAuthenticated,
    },
    {
        path: '/qualita/aggiornanc/',
        name: 'qualita-aggiorna-nc',
        redirect: legacyNcRedirect,
    },
]
